import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/uxp-photoshop/uxp-photoshop/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "layers"
    }}>{`Layers`}</h1>
    <p>{`A collections class allowing for array access into the applications
list of layers on a document,
while also providing familiar methods from ExtendScript, like `}<inlineCode parentName="p">{`getByName`}</inlineCode></p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Iterate through all the top layers of frontmost document
app.activeDocument.layers.forEach(h => console.log(h.name));
`}</code></pre>
    <h2 {...{
      "id": "hierarchy"
    }}>{`Hierarchy`}</h2>
    <ul>
      <li parentName="ul">
        <p parentName="li"><em parentName="p">{`Array`}</em>{`<`}<a parentName="p" {...{
            "href": "/photoshop/uxp/ps_reference/classes/layer/"
          }}><em parentName="a">{`Layer`}</em></a>{`>`}</p>
        <p parentName="li">{`↳ `}<strong parentName="p">{`Layers`}</strong></p>
      </li>
    </ul>
    <h2 {...{
      "id": "indexable"
    }}>{`Indexable`}</h2>
    <p>{`▪ `}{`[index: `}<em parentName="p">{`number`}</em>{`]`}{`: `}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a></p>
    <p>{`Used to access the layers in the collection`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// Iterate through all the top layers of frontmost document
app.activeDocument.layers.forEach(h => console.log(h.name));
`}</code></pre>
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Access`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`length`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`number`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number of `}<a parentName="td" {...{
              "href": "/photoshop/uxp/ps_reference/modules/layer/"
            }}>{`Layer`}</a>{` elements in this collection`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`typename`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Read-only`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The name for this object collection: Layers`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "methods"
    }}>{`Methods`}</h2>
    <h3 {...{
      "id": "add"
    }}>{`add`}</h3>
    <p><strong parentName="p">{`async`}</strong>{` : `}<em parentName="p">{`Promise`}</em>{`<`}<a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a>{`>`}</p>
    <p>{`Create a new layer.`}</p>
    <hr></hr>
    <h3 {...{
      "id": "getbyname"
    }}>{`getByName`}</h3>
    <p><a parentName="p" {...{
        "href": "/photoshop/uxp/ps_reference/classes/layer/"
      }}><em parentName="a">{`Layer`}</em></a></p>
    <p>{`Find the first layer with the matching name`}</p>
    <h4 {...{
      "id": "parameters"
    }}>{`Parameters`}</h4>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`name`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}><em parentName="td">{`string`}</em></td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      